/* ==========================================================================
   PanelRoom > Template
   ========================================================================== */

/* Import modules */
const { html } = require('common-tags');

const { addData, addStyle, prepareDataConfig } = require('@bluekiri/alexandria/helpers/dataHelpers');

const { sanitizeSingleQuote } = require('@bluekiri/alexandria-contrib-components/helpers/sanitize');

const CounterTemplate = require('@bluekiri/alexandria-contrib-components/components/counter-rxjs/template');
const ButtonTemplate = require('@bluekiri/alexandria-contrib-components/components/button-rxjs/template');

const configuration = require('./client/js/config');

/* Render counter */
const renderCounter = (data, context) => {
    const { min, max, value, personsLabel = '', personDescription = '', type, options = false } = data;

    const dataCounter = addData(
        {
            min: value === 0 ? 0 : min,
            max,
            value,
            label: personsLabel,
            description: personDescription
        },
        { type }
    );

    return html(`
        <div class="${configuration().css.self}__item ${!options ? '' : configuration().css.children}">
            ${CounterTemplate(dataCounter, context)}
        </div>
    `);
};

const renderPeople = (data, context) => {
    if (!data.people || data.people.length === 0) return html('');

    const { people = [] } = data;

    const template = people.map((counter, ind) => {
        const type = `${configuration().type.counter}-${ind}`;

        return renderCounter({ ...counter, type }, context);
    });

    return html(template);
};

/* Button delete */
const deleteButton = (content, hasDelete = false, context = {}) => {
    if (!hasDelete) return html('');

    return ButtonTemplate(
        addStyle(
            addData(
                {
                    icon: 'cancel'
                },
                {
                    type: configuration().type.delete
                }
            ),
            [configuration().css.delete]
        ),
        context
    );
};

const getPeople = data => {
    const people = data.map(item => {
        const { options: dataOptions = [] } = item;

        if (!dataOptions.length) return item;

        const hasDefaultOption = dataOptions.some(option => option.selected);
        const options = hasDefaultOption
            ? dataOptions
            : dataOptions.map((option, ind) => ({ ...option, selected: ind === 0 }));

        return { ...item, options };
    });

    return people;
};

/**
 * PanelRoom template
 * @param {object} data Object containing the data model for this component.
 * @returns {string} html
 */
module.exports = function Template(data = {}, context = {}) {
    /* Data */
    if (!data.people) return html('');

    const { config = {}, people = [] } = data;
    const { styles = [], literals = {}, hasTitle = true, hasDelete = false } = config;
    const style = configuration().css.self;
    const hasTitleStyle = hasTitle ? configuration().css.withTitle : '';
    const { dataType } = prepareDataConfig(config.data);
    const dataTypAttr = dataType ? html(`data-type="${dataType}"`) : html('');

    /* Literals */
    const { roomLabel, deleteLabel = '' } = literals;

    const configData = {
        context,
        ...config,
        people: getPeople(people)
    };

    const dataConfigAttr = html(`data-config='${sanitizeSingleQuote(JSON.stringify({ ...configData }))}'`);

    const renderTitle = hasTitle
        ? html(
              `<div class='${style}__title'>
                <p class="${style}__label" ${configuration().hooks.label}>${roomLabel}</p>
                ${deleteButton(deleteLabel, hasDelete, context)}</div>`
          )
        : html('');

    return html(`
        <div class="${[style, hasTitleStyle, ...styles].join(' ').trim('')}"
            data-component="${configuration().component}"
            ${dataTypAttr}
            ${dataConfigAttr}>
            ${renderTitle}
            <div class='${style}__wrapper'>
                ${renderPeople(data, context)}
            </div>
        </div>
    `);
};
